export default __webpack_public_path__ + "static/media/talk-down.a962a94b.png";